import React from 'react';
import PropTypes from 'prop-types';

function ErrorMessage({ error, fullPage = false }) {
  return (
    <div
      className={`${
        fullPage
          ? 'flex items-center justify-center h-screen'
          : 'p-4 bg-red-50 border-l-4 border-red-400 text-red-700'
      }`}
    >
      <div className={`${fullPage ? 'text-center' : ''}`}>
        <h1 className={`font-bold ${fullPage ? 'text-2xl text-red-600' : ''}`}>
          Error
        </h1>
        <p className={`${fullPage ? 'mt-2 text-gray-700' : ''}`}>{error}</p>
      </div>
    </div>
  );
}

ErrorMessage.propTypes = {
  error: PropTypes.string.isRequired,
  fullPage: PropTypes.bool,
};

export default ErrorMessage;
